import src from "./texture-grain.png"

const width = 200
const height = 200
export default { src, width, height }
